import { render, staticRenderFns } from "./comCard.vue?vue&type=template&id=65296d27&scoped=true"
import script from "./comCard.vue?vue&type=script&lang=ts"
export * from "./comCard.vue?vue&type=script&lang=ts"
import style0 from "./comCard.vue?vue&type=style&index=0&id=65296d27&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65296d27",
  null
  
)

export default component.exports